import { createContext, useContext } from 'react'
import { UseOrderTileResult } from './useOrderTile'
import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

export const OrderTileContext = createContext<UseOrderTileResult['data'] | null>(null)

OrderTileContext.displayName = 'OrderTileContext'

export const useOrderTileContext = () => {
  const hook = useContext(OrderTileContext)

  if (hook === null) {
    const errorMessage = 'OrderTileContext value is null'
    datadogLogs.logger.error(errorMessage)
    datadogRum.addError(new Error(errorMessage), {
      page: 'MyGoustoPage',
      errorMessage: errorMessage,
    })

    throw new Error('OrderTileContext value is null')
  }

  return hook
}
